var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"RkmForm"},[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-textarea',{attrs:{"validations":_vm.validations.orientacoes},model:{value:(_vm.model.orientacoes),callback:function ($$v) {_vm.$set(_vm.model, "orientacoes", $$v)},expression:"model.orientacoes"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }